package com.esoris.kmpmoout.modules

import com.esoris.kmpmoout.domaindata.product.*
import org.koin.dsl.module

val webModule = module {

    single<ProductRepository> {

        LocalStorageProductRepositoryImpl()
    }

}